<div class="data-preview-outer-wrapper">

    <div *ngIf="inlineMode" class="back-to-task-btn" (click)="backToNewTask()">
        <mat-icon>chevron_left</mat-icon> <span>Back to Tasking</span>
    </div>
    <mat-tab-group>
        <mat-tab label="Sensor">
            <app-taskcost-sensor-preview
            [showCloseButton]="data?.isDialogBox??false"
            (closeRequested)="closeDialog()"></app-taskcost-sensor-preview>
        </mat-tab>
        <mat-tab label="Feeds" *ngIf="!data?.isDialogBox && !isStarterUser">
            <app-feeds-data-preview></app-feeds-data-preview>
        </mat-tab>
        <mat-tab label="Indices" *ngIf="!data?.isDialogBox">
            <app-indices-preview ></app-indices-preview>
        </mat-tab>
    </mat-tab-group>
</div>